export const getFirstPhoneValue = (phones) => {
  if (!Array.isArray(phones)) {
    return "";
  }
  const phoneObj = phones.find((phone) => phone?.value);
  return phoneObj?.value ?? "";
};

export const resolvePhones = ({ formHeader, actionItem }) => {
  const clientPhone = formHeader?.client_phone ?? actionItem?.onCase?.client?.phone ?? "";
  const providerPhone =
    getFirstPhoneValue(formHeader?.provider_phones) ||
    formHeader?.provider_phone ||
    actionItem?.onProvider?.phone ||
    "";
  const lawFirmPhone = formHeader?.law_firm_phone ?? actionItem?.onFirm?.phone ?? "";

  return { clientPhone, providerPhone, lawFirmPhone };
};

export const buildCallActions = ({ isDataEntryFollowUp, headerType, phones, onCall }) => {
  if (isDataEntryFollowUp) {
    return [];
  }

  const actions = [];
  if (phones.clientPhone) {
    actions.push({
      key: "call-client",
      label: "Call Client",
      icon: "his-person",
      onClick: () => onCall(phones.clientPhone),
    });
  }

  if (phones.providerPhone) {
    actions.push({
      key: "call-provider",
      label: "Call Provider",
      icon: "his-handshake-heart",
      onClick: () => onCall(phones.providerPhone),
    });
  }

  if (phones.lawFirmPhone && headerType === "law_firm_focused_header") {
    actions.push({
      key: "call-law-firm",
      label: "Call Law Firm",
      icon: "his-law-firm",
      onClick: () => onCall(phones.lawFirmPhone),
    });
  }

  return actions;
};

export const buildDetailActions = ({
  isDataEntryFollowUp,
  resolvedCaseId,
  headerType,
  formHeader,
  onClientDetails,
  onProviderDetails,
  onEditDocument,
}) => {
  if (isDataEntryFollowUp) {
    return [];
  }

  const actions = [];
  if (resolvedCaseId) {
    actions.push({
      key: "client-details",
      label: "Client Details",
      icon: "his-person",
      onClick: onClientDetails,
    });
  }

  if (formHeader?.provider_id) {
    actions.push({
      key: "provider-details",
      label: "Provider Details",
      icon: "his-handshake-heart",
      onClick: onProviderDetails,
    });
  }

  if (headerType === "document_focused_header" && formHeader?.document_id) {
    actions.push({
      key: "edit-document",
      label: "Edit Document",
      icon: "his-file-search",
      onClick: onEditDocument,
    });
  }

  return actions;
};
